// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://use.typekit.net/oob4opl.css);"]);
// Module
exports.push([module.id, ".ReactModalPortal {\n  position: relative;\n  z-index: 4; }\n\n.Modal__wrapper {\n  background: white;\n  outline: none; }\n\n@media only screen and (max-width: 767px) {\n  .Modal__wrapper {\n    max-width: 90% !important; } }\n", ""]);
// Exports
module.exports = exports;
